import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {SelectField} from "./FilterComponentStyles";
import {useObserver} from "mobx-react-lite";

const ShiftScoreCourierStatusFilter = ({
    showAllOption = false,
    allKey = "all",
    hideTitle = false,
    selectMarginBottom = "20px",
    optionFilter = () => {
        return true;
    },
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && <h5>{"Kurye Durumu"}</h5>}
            <SelectField
                allowClear
                showSearch
                mb={selectMarginBottom}
                data-testid="courierStatusSelect"
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value={allKey} data-testid="courierStatusSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}

                <SelectField.Option
                    key={"active"}
                    value={"active"}
                    data-testid="courierStatusSelect_option"
                >
                    Aktif
                </SelectField.Option>
                <SelectField.Option
                    key={"inactive"}
                    value={"inactive"}
                    data-testid="courierStatusSelect_option"
                >
                    Meşgul
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    ));
};

export default ShiftScoreCourierStatusFilter;
